import React from "react";

import { Outlet } from "react-router-dom";

import AnswersContext from "../contexts/AnswersContext";
import useAnswers from "../hooks/useAnswers";

const WithAnswers = () => {
  const { answers, getAnswer, onAnswerChange, resetAnswers } = useAnswers();
  return (
    <AnswersContext.Provider
      value={{
        answers: answers,
        getAnswer: getAnswer,
        onAnswerChange: onAnswerChange,
        resetAnswers: resetAnswers,
      }}
    >
      <Outlet />
    </AnswersContext.Provider>
  );
};

export default WithAnswers;
